import React, { useContext, useEffect } from 'react'
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import { Description } from '../../ui-helper-elements'

function HoverProratedDays() {
   const state = useQuoteContext()
   const { getString, getFormattedString } = state

   // Function to format date to MM/DD/YYYY
   function formatDate(dateString) {
      const [year, month, day] = dateString.split('-')
      return `${month}/${day}/${year}`
   }

   function formatLastInvoiceDate(date) {
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
      const day = date.getUTCDate().toString().padStart(2, '0')
      const year = date.getUTCFullYear()
      return `${month}/${day}/${year}`
   }

   // Find date of last invoice. If the day of the month of billing date is greater than the last day of the (I.E someone is billed on the 30th normally, but it is February and the onth only has 28 days), then use the last day of the month instead.
   let dateOfFutureInvoice = new Date(state.nextInvoiceDate)
   let dateOfLastInvoice = new Date(dateOfFutureInvoice)
   if (
      new Date(
         Date.UTC(
            dateOfFutureInvoice.getUTCFullYear(),
            dateOfFutureInvoice.getUTCMonth() - 1,
            dateOfFutureInvoice.getUTCDate(),
         ),
      ) >
      new Date(
         Date.UTC(
            dateOfFutureInvoice.getUTCFullYear(),
            dateOfFutureInvoice.getUTCMonth() - 1,
         ),
      )
   ) {
      dateOfLastInvoice.setUTCFullYear(dateOfFutureInvoice.getUTCFullYear())
      dateOfLastInvoice.setUTCMonth(dateOfFutureInvoice.getUTCMonth() - 1)
      dateOfLastInvoice.setUTCDate(dateOfFutureInvoice.getUTCDate())
      // If the billing date would have been past the last day of the month (IE into the next month), set the billing date to the last day of the month.
      if (
         dateOfLastInvoice.getUTCMonth() == dateOfFutureInvoice.getUTCMonth()
      ) {
         dateOfLastInvoice.setUTCMonth(dateOfLastInvoice.getUTCMonth())
         dateOfLastInvoice.setUTCDate(0)
      }
   } else {
      dateOfLastInvoice.setUTCFullYear(dateOfFutureInvoice.getUTCFullYear())
      dateOfLastInvoice.setUTCMonth(dateOfFutureInvoice.getUTCMonth() - 1)
      dateOfLastInvoice.setUTCDate(dateOfFutureInvoice.getUTCDate())
   }

   return (
      <Description
         className='col col-bhr-red'
         title='Proration Details'
         content={
            <>
               <div className='row'>
                  <div className='col text-nowrap'>
                     <b>
                        {getString(
                           'product.HoverProratedDays.Header.LastInvoice',
                        )}
                     </b>
                  </div>
                  <div className='col text-end'>
                     {formatLastInvoiceDate(dateOfLastInvoice)}
                  </div>
               </div>
               <div className='row'>
                  <div className='col text-nowrap'>
                     <b>
                        {getString(
                           'product.HoverProratedDays.Header.NextInvoice',
                        )}
                     </b>
                  </div>
                  <div className='col text-end'>
                     {formatDate(state.nextInvoiceDate)}
                  </div>
               </div>
               <div className='row'>
                  <div className='col text-nowrap'>
                     <b>
                        {getString(
                           'product.HoverProratedDays.Header.ActivationDate',
                        )}
                     </b>
                  </div>
                  <div className='col text-end'>
                     {formatDate(state.activationDate)}
                  </div>
               </div>
               <div className='row'>
                  <div className='col text-nowrap'>
                     <b>
                        {getString(
                           'product.HoverProratedDays.Header.DaysFromActivation',
                        )}
                     </b>
                  </div>
                  <div className='col text-end'>
                     {state.proratedActivationDetails.daysToPayAfterActivation}
                  </div>
               </div>
               <div className='row'>
                  <div className='col text-nowrap'>
                     <b>
                        {getString(
                           'product.HoverProratedDays.Header.DaysBetweenInvoices',
                        )}
                     </b>
                  </div>
                  <div className='col text-end'>
                     {state.proratedActivationDetails.totalDaysInMonth}
                  </div>
               </div>
               <div className='row'>
                  <div className='col text-nowrap'>
                     <b>
                        {getString(
                           'product.HoverProratedDays.Header.ProrationDays',
                        )}
                     </b>
                  </div>
                  <div className='col text-end'>
                     {state.proratedActivationDetails.daysPaidInMonth}
                  </div>
               </div>
            </>
         }
      >
         <span className='hoverable'>
            {getFormattedString('product.HoverProratedDays.Hoverable.Text', {
               daysPaidInMonth: state.proratedActivationDetails.daysPaidInMonth,
            })}
         </span>
      </Description>
   )
}

export default HoverProratedDays
